/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import { IDropdownOptionProps } from "../DropdownOption/DropdownOption";
import { ISet } from "../Select/Select.interface";
import { SelectOption } from "../SelectOption/SelectOption";
import Price from "../../../DataDisplay/Price/Price";
import { extractCurrentPrice } from "../../../DataDisplay/Price/ProductPrice";

function BundleOption({
  item: { prices, title },
  item,
  classes,
  variant,
  labelKey,
  valueKey,
  onSelect,
}: IDropdownOptionProps<ISet>): JSX.Element {
  const mainPrice = extractCurrentPrice(prices);
  return (
    <SelectOption<ISet>
      item={item}
      variant={variant}
      classes={classes}
      labelKey={labelKey}
      valueKey={valueKey}
      onSelect={onSelect}
    >
      <div className="d-flex justify-content-between w-100 lh-24">
        <div
          className="max-lines max-lines--2 overflow-hidden me-4 me-lg-6 flex-grow-1 flex-shrink-1"
          title={title}
        >
          {title}
        </div>
        <div className="font-weight-regular flex-grow-0 flex-shrink-0">
          <Price {...mainPrice} />
        </div>
      </div>
    </SelectOption>
  );
}

export default BundleOption;
